export const CUSTOM_FIELD_PREFIX = 'custom_field:';
export var LegislativeItemWorkflowStepStatus;
(function (LegislativeItemWorkflowStepStatus) {
    LegislativeItemWorkflowStepStatus["Pending"] = "pending";
    LegislativeItemWorkflowStepStatus["InProgress"] = "in_progress";
    LegislativeItemWorkflowStepStatus["Completed"] = "completed";
    LegislativeItemWorkflowStepStatus["Skipped"] = "skipped";
})(LegislativeItemWorkflowStepStatus || (LegislativeItemWorkflowStepStatus = {}));
export var LegislativeItemWorkflowAssignmentStatus;
(function (LegislativeItemWorkflowAssignmentStatus) {
    LegislativeItemWorkflowAssignmentStatus["Pending"] = "pending";
    LegislativeItemWorkflowAssignmentStatus["Approved"] = "approved";
    LegislativeItemWorkflowAssignmentStatus["Rejected"] = "rejected";
})(LegislativeItemWorkflowAssignmentStatus || (LegislativeItemWorkflowAssignmentStatus = {}));
export var LegislativeItemWorkflowStepType;
(function (LegislativeItemWorkflowStepType) {
    LegislativeItemWorkflowStepType["Confirmation"] = "confirmation";
    LegislativeItemWorkflowStepType["NotificationOnly"] = "notification_only";
    LegislativeItemWorkflowStepType["ApproveReject"] = "approve_reject";
    LegislativeItemWorkflowStepType["DocumentCreate"] = "document_create";
    LegislativeItemWorkflowStepType["ToDeliberation"] = "to_deliberation";
})(LegislativeItemWorkflowStepType || (LegislativeItemWorkflowStepType = {}));
export var WorkflowActionType;
(function (WorkflowActionType) {
    WorkflowActionType["Submit"] = "submit";
    WorkflowActionType["Approve"] = "approve";
    WorkflowActionType["Reject"] = "reject";
    WorkflowActionType["Confirm"] = "confirm";
    WorkflowActionType["Cancel"] = "cancel";
    WorkflowActionType["Undo"] = "undo";
    WorkflowActionType["StatusChange"] = "status_change";
    WorkflowActionType["StepAdvance"] = "step_advance";
    WorkflowActionType["StepReset"] = "step_reset";
    WorkflowActionType["StepAdded"] = "step_added";
    WorkflowActionType["StepSkipped"] = "step_skipped";
    WorkflowActionType["ConditionsEvaluated"] = "conditions_evaluated";
    WorkflowActionType["NotificationSent"] = "notification_sent";
    WorkflowActionType["DocumentAttached"] = "document_attached";
    WorkflowActionType["AssignmentCreated"] = "assignment_created";
    WorkflowActionType["AssignmentRemoved"] = "assignment_removed";
    WorkflowActionType["Recall"] = "recall";
})(WorkflowActionType || (WorkflowActionType = {}));
export var LegislativeItemWorkflowAssignmentType;
(function (LegislativeItemWorkflowAssignmentType) {
    LegislativeItemWorkflowAssignmentType["User"] = "user";
    LegislativeItemWorkflowAssignmentType["EntityPosition"] = "entity_position";
    LegislativeItemWorkflowAssignmentType["DepartmentPosition"] = "department_position";
    LegislativeItemWorkflowAssignmentType["ParentDepartmentPosition"] = "parent_department_position";
    LegislativeItemWorkflowAssignmentType["Creator"] = "creator";
    LegislativeItemWorkflowAssignmentType["StaffContact"] = "staff_contact";
})(LegislativeItemWorkflowAssignmentType || (LegislativeItemWorkflowAssignmentType = {}));
/**
 * Assignment types that resolve to a user dynamically at runtime and therefore
 * do not require a configured `id`.
 */
export const LEGISLATIVE_ITEM_WORKFLOW_DYNAMIC_ASSIGNMENT_TYPES = [
    LegislativeItemWorkflowAssignmentType.Creator,
    LegislativeItemWorkflowAssignmentType.StaffContact,
];
/**
 * Human-readable note describing who a dynamic assignment type resolves to.
 */
export const LegislativeItemWorkflowDynamicAssignmentDescriptions = {
    [LegislativeItemWorkflowAssignmentType.Creator]: 'Assigned to the item creator',
    [LegislativeItemWorkflowAssignmentType.StaffContact]: 'Assigned to the item staff contacts',
};
/**
 * Type guard for assignment types that resolve to a user dynamically at runtime
 * and do not require a configured `id`.
 * @param type - The assignment type to check
 */
export const isDynamicLegislativeItemWorkflowAssignmentType = (type) => LEGISLATIVE_ITEM_WORKFLOW_DYNAMIC_ASSIGNMENT_TYPES.includes(type);
export var ConditionOperator;
(function (ConditionOperator) {
    ConditionOperator["Equal"] = "equal";
    ConditionOperator["NotEqual"] = "not_equal";
    ConditionOperator["Contains"] = "contains";
    ConditionOperator["NotContains"] = "not_contains";
    ConditionOperator["GreaterThan"] = "greater_than";
    ConditionOperator["LessThan"] = "less_than";
    ConditionOperator["GreaterThanOrEqual"] = "greater_than_or_equal";
    ConditionOperator["LessThanOrEqual"] = "less_than_or_equal";
})(ConditionOperator || (ConditionOperator = {}));
export const conditionOperatorLabels = {
    [ConditionOperator.Equal]: 'Equal',
    [ConditionOperator.NotEqual]: 'Not Equal',
    [ConditionOperator.Contains]: 'Contains',
    [ConditionOperator.NotContains]: 'Does Not Contain',
    [ConditionOperator.GreaterThan]: 'Greater Than',
    [ConditionOperator.LessThan]: 'Less Than',
    [ConditionOperator.GreaterThanOrEqual]: 'Greater Than or Equal',
    [ConditionOperator.LessThanOrEqual]: 'Less Than or Equal',
};
export var FieldPermission;
(function (FieldPermission) {
    FieldPermission["Hidden"] = "hidden";
    FieldPermission["ViewOnly"] = "view_only";
    FieldPermission["Editable"] = "editable";
    FieldPermission["Required"] = "required";
})(FieldPermission || (FieldPermission = {}));
export const fieldPermissions = {
    [FieldPermission.Hidden]: 'Hidden',
    [FieldPermission.ViewOnly]: 'View Only',
    [FieldPermission.Editable]: 'Editable',
    [FieldPermission.Required]: 'Required',
};
export const LegislativeItemWorkflowStepOptions = {
    [LegislativeItemWorkflowStepType.Confirmation]: 'Confirmation',
    [LegislativeItemWorkflowStepType.NotificationOnly]: 'Notification Only',
    [LegislativeItemWorkflowStepType.ApproveReject]: 'Approve/Reject',
    [LegislativeItemWorkflowStepType.DocumentCreate]: 'Document Create',
    [LegislativeItemWorkflowStepType.ToDeliberation]: 'To Deliberation',
};
export const LegislativeItemWorkflowStepOptionsDescription = {
    [LegislativeItemWorkflowStepType.Confirmation]: 'Confirmation only without an option to reject',
    [LegislativeItemWorkflowStepType.NotificationOnly]: 'Sends notifications without requiring action and automatically moves to the next step',
    [LegislativeItemWorkflowStepType.ApproveReject]: 'Makes approval or rejection decisions',
    [LegislativeItemWorkflowStepType.DocumentCreate]: 'Generates required documents',
    [LegislativeItemWorkflowStepType.ToDeliberation]: 'Moves item to the Deliberation state, allowing it to be placed on agendas',
};
export const LegislativeItemWorkflowAssignmentOptions = {
    [LegislativeItemWorkflowAssignmentType.User]: 'User',
    [LegislativeItemWorkflowAssignmentType.EntityPosition]: 'Entity Position',
    [LegislativeItemWorkflowAssignmentType.DepartmentPosition]: 'Department Position',
    [LegislativeItemWorkflowAssignmentType.ParentDepartmentPosition]: 'Parent Department Position',
    [LegislativeItemWorkflowAssignmentType.Creator]: 'Item Creator',
    [LegislativeItemWorkflowAssignmentType.StaffContact]: 'Staff Contact',
};
export var RejectionPolicyType;
(function (RejectionPolicyType) {
    RejectionPolicyType["ToBeginning"] = "to_beginning";
    RejectionPolicyType["ToStep"] = "to_step";
    RejectionPolicyType["Kill"] = "kill";
})(RejectionPolicyType || (RejectionPolicyType = {}));
export var ConditionsType;
(function (ConditionsType) {
    ConditionsType["Execute"] = "execute";
    ConditionsType["Skip"] = "skip";
})(ConditionsType || (ConditionsType = {}));
export const conditionsTypeLabels = {
    [ConditionsType.Execute]: 'Include step',
    [ConditionsType.Skip]: 'Skip step',
};
export var ConditionsOperand;
(function (ConditionsOperand) {
    ConditionsOperand["All"] = "all";
    ConditionsOperand["Some"] = "some";
})(ConditionsOperand || (ConditionsOperand = {}));
export const conditionsOperandLabels = {
    [ConditionsOperand.All]: 'All conditions match',
    [ConditionsOperand.Some]: 'Any condition matches',
};
export const LegislativeItemWorkflowRejectionPolicyTypeOptions = {
    [RejectionPolicyType.ToBeginning]: 'To Beginning',
    [RejectionPolicyType.ToStep]: 'To Step',
    [RejectionPolicyType.Kill]: 'Kill',
};
export const LegislativeItemFields = {
    shortTitle: {
        field: 'shortTitle',
        label: 'Short Title',
        type: 'string',
    },
    fullTitle: {
        field: 'fullTitle',
        label: 'Full Title',
        type: 'string',
    },
    summary: {
        field: 'summary',
        label: 'Summary',
        type: 'string',
    },
    fiscalNote: {
        field: 'fiscalNote',
        label: 'Fiscal Note',
        type: 'string',
    },
    internalNotes: {
        field: 'internalNotes',
        label: 'Internal Notes',
        type: 'string',
    },
    departmentId: {
        field: 'departmentId',
        label: 'Department',
        type: 'department',
    },
    staffContactId: {
        field: 'staffContactId',
        label: 'Staff Contact',
        type: 'user',
    },
    executiveSession: {
        field: 'executiveSession',
        label: 'Executive Session',
        type: 'boolean',
    },
    requestingEmergency: {
        field: 'requestingEmergency',
        label: 'Requesting Emergency',
        type: 'boolean',
    },
    requestingConsent: {
        field: 'requestingConsent',
        label: 'Requesting Consent',
        type: 'boolean',
    },
    publicHearing: {
        field: 'publicHearing',
        label: 'Public Hearing',
        type: 'boolean',
    },
    recommendedActionId: {
        field: 'recommendedActionId',
        label: 'Recommended Action',
        type: 'recommendedAction',
    },
    recommendedActionText: {
        field: 'recommendedActionText',
        label: 'Recommended Action Text',
        type: 'string',
    },
    meetingBodyId: {
        field: 'meetingBodyId',
        label: 'Meeting Body',
        type: 'meetingBody',
    },
};
export const DEFAULT_LEGISLATIVE_ITEM_WORKFLOW_TEMPLATE = {
    name: 'Standard Approval Workflow',
    status: 'published',
    legislativeItemWorkflowTemplateSteps: [
        {
            name: 'Review Step',
            orderById: 1,
            subOrderById: 0,
            stepType: LegislativeItemWorkflowStepType.ApproveReject,
            assignments: [
                {
                    type: LegislativeItemWorkflowAssignmentType.User,
                    id: 0,
                },
            ],
            rejectionPolicies: [
                {
                    value: RejectionPolicyType.Kill,
                },
            ],
            minApprovals: 1,
            deadlineDays: null,
            conditions: [],
            fieldPermissions: [],
        },
    ],
};
